import { Button, Modal, Typography } from '@automata/ui';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { FC, useState } from 'react';

import { DataFieldForm } from './DataFieldForm';
import type { AdditionalDataInput } from '../../../../types';

export interface EditDataFieldModalProps {
  open: boolean;
  onClose: () => void;
  field: AdditionalDataInput;
  onSave: (fieldId: string, updatedField: AdditionalDataInput) => void;
  onDelete: (fieldId: string) => void;
  existingFieldIds: string[];
}

export const EditDataFieldModal: FC<EditDataFieldModalProps> = ({
  open,
  onClose,
  field,
  onSave,
  onDelete,
  existingFieldIds,
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleDelete = () => {
    onDelete(field.id);
    setDeleteDialogOpen(false);
    onClose();
  };

  const handleSave = (updatedField: AdditionalDataInput) => {
    onSave(field.id, updatedField);
    onClose();
  };

  const handleOpenDeleteDialog = () => {
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={onClose} title="Edit data field">
        <Stack gap={1} alignItems="flex-start">
          <Typography variant="body2" color="text.secondary">
            Edit the additional information required for this data field.
          </Typography>

          <Stack gap={2} width="100%">
            <DataFieldForm
              onSubmit={handleSave}
              onCancel={onClose}
              existingFieldIds={existingFieldIds}
              initialData={field}
              currentFieldId={field.id}
              submitButtonText="Save Changes"
              handleOpenDeleteDialog={handleOpenDeleteDialog}
            />
          </Stack>
        </Stack>
      </Modal>

      <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete field?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this field? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCloseDeleteDialog}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
